<div>
	<app-dropdown-columns-positions [widget]="widget()" />
</div>
